import gql from 'graphql-tag'

export const Q_GET_TIME_PERFORMANCE_REPORT = gql`query ($startDate:String, $endDate:String, $currentTeam:String, $xCompany:String, $topNLimit:Int, $leastNLimit:Int, $fromMachine:Boolean) {
   timePerformanceReport(startDate:$startDate, endDate: $endDate, currentTeam:$currentTeam, xCompany:$xCompany, topNLimit:$topNLimit, leastNLimit:$leastNLimit, fromMachine:$fromMachine) {
         topN {
             name
             score
             group
             jobTitle
             absentDays
             unApprovedAbsent
             lateHrs
             missedPunches
         }
         leastN {
             name
             score
             group
             jobTitle
             absentDays
             unApprovedAbsent
             lateHrs
             missedPunches
         }
   }
}`

export const Q_GET_TOPPERFORMERS = gql`query ($startDate:String, $endDate:String, $currentTeam:String, $limit:Int, $thresholdScore:Int, $fromMachine:Boolean) {
   topPerformers(startDate:$startDate, endDate: $endDate, currentTeam:$currentTeam, limit:$limit, thresholdScore:$thresholdScore, fromMachine:$fromMachine) {
         score,
         fullPayHours,
         name
         group
         mateId


   }

}`

export const Q_GET_LEASTPERFORMERS = gql`query ($startDate:String, $endDate:String, $currentTeam:String, $limit:Int,$thresholdScore:Int, $fromMachine:Boolean) {
   leastPerformers(startDate:$startDate, endDate: $endDate, currentTeam:$currentTeam,thresholdScore:$thresholdScore, limit:$limit, fromMachine:$fromMachine) {
         score,
         fullPayHours,
         name
         group
         mateId


   }

}`
